import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AltText, Chart } from 'src/app/shared/interfaces';
import { FeatureFlagService } from '../../feature-flags/services/feature-flag/feature-flag.service';
import { FeatureFlags } from 'src/app/shared/enums/feature-flags';

export interface ExpandedContent {
  chart: Chart;
  imageSrc: string;
  imageAlt: AltText[];
}

@Injectable({
  providedIn: 'root',
})
export class ExpandedContentService {
  constructor(private featureFlagService: FeatureFlagService) {}

  readonly defaultState: ExpandedContent = {
    chart: { data: '', isUrl: false },
    imageSrc: '',
    imageAlt: [],
  };
  private expandedContent$ = new BehaviorSubject<ExpandedContent>({
    ...this.defaultState,
  });
  private isOpen$ = new BehaviorSubject<boolean>(false);

  getExpandedContent(): Observable<ExpandedContent> {
    return this.expandedContent$.asObservable();
  }

  isOpen(): Observable<boolean> {
    return this.isOpen$.asObservable();
  }

  openChart(chart: Chart): void {
    if (
      !this.featureFlagService.isFlagEnabled(FeatureFlags.EXPANDABLE_CONTENT)
    ) {
      return;
    }

    this.expandedContent$.next({
      ...this.defaultState,
      chart,
    });
    this.isOpen$.next(true);
  }

  openImage(src: string, alt: AltText[]): void {
    if (
      !this.featureFlagService.isFlagEnabled(FeatureFlags.EXPANDABLE_CONTENT)
    ) {
      return;
    }

    this.expandedContent$.next({
      ...this.defaultState,
      imageSrc: src,
      imageAlt: alt,
    });
    this.isOpen$.next(true);
  }

  close(): void {
    this.expandedContent$.next({
      ...this.defaultState,
    });
    this.isOpen$.next(false);
  }
}
